import { Link } from 'react-router';
import React, { Component } from 'react';
import LoaderButton from './LoaderButton';
import { Form } from 'react-bootstrap';
import '../styles/Login.css';
import './LogoImg';

class ConfirmError extends Component {
  constructor(props) {
    super(props);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  UNSAFE_componentWillMount() {
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  handleFormSubmit(e) {
    e.preventDefault();
    this.props.router.push('/');
  }

  render() {
    return (
      <div className='Login'>
        <div className='login-form'>
          <div className='Login text-center' >
            <div className='card-confirm'>
              <br />
              <LogoImg />
              <br />
              <div className='signal34-confirm'>
                Error!
              </div>
              <br />
              <br />
              <div className='signal34-confirm-error'>
                Your email can't be confirmed.
              </div>
              <br />
              <div className='signal34-confirm-error'>
                Please verify it and try again.
              </div>
              <br />
              <Form onSubmit={this.handleFormSubmit}>
                <div className='signal34-blue-button'>
                  <LoaderButton className="signal34-bnt-default" variant="outline-secondary" type='submit' text='Return to Home Page' loadingText='Submit…' />
                </div>
                <br />
              </Form>
            </div>
          </div>
        </div>
        <footer>
          <div className='text-center small copyright signal34-footer'>
            <div>
              <span>© 2019 Signal34</span> | <a target='_blank' href='./about'>About</a> | <Link to={'/'}>Home</Link> | <Link to={'/signup'}>Sign Up</Link> | <a target='_blank' href='./howto'>HowTo</a> | <a target='_blank' href='./personal_terms_of_service'>Terms of Service</a> | <a target='_blank' href='./privacy_policy'>Privacy policy</a>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}

export default ConfirmError;
